import type { RequestConfig } from '@customTypes/index';
import type { ArtistItem, PaginatedResponse } from '@customTypes/types';

import { api } from '@/shared/api/instance';

export type GetArtistsActivityListParams = RequestConfig;

export const getArtistsActivityList = async ({
  config
}: GetArtistsActivityListParams) =>
  api.get<PaginatedResponse<ArtistItem[]>>(
    `/api/UserActivities/all-artists`,
    config
  );
